import { useRef, useState } from 'react';
import Slider, { Settings } from 'react-slick';

/**
 * Carousel Props
 */
type CarouselProps = Settings & {
  /**
   * Dots theme
   */
  dotsTheme?: 'dark' | 'light';
  /**
   * Arrows theme
   */
  arrowsTheme?: 'dark' | 'light';
  /**
   * Arrow size
   */
  arrowSize?: 'sm' | 'md';
  /**
   * show other icon arrow view
   */
  arrowSlider?: boolean;
  /**
   * is arrows outside carousel
   */
  isArrowsOutside?: boolean;
  /**
   * Container class name
   */
  containerClassName?: any;

   className?: any;
    nextArrow?: any;
    arrows?: any;
    dots?: any;
    infinite?: any;
};

/**
 * Use Carousel
 */
const useCarousel = (_: CarouselProps) => {
  const carouselRef = useRef<Slider>(null);

  const [selectedIndex, setSelectedIndex] = useState(0);

  const checkIsArrowHidden = (key: string, childrenCount: number) =>
    (key === 'prev' && selectedIndex === 0) ||
    (key === 'next' && childrenCount === selectedIndex + 1);

  const onPrevClick = () => {
    carouselRef.current.slickPrev();
  };

  const onNextClick = () => {
    carouselRef.current.slickNext();
  };


  return {
    selectedIndex,
    carouselRef,
    setSelectedIndex,
    onPrevClick,
    onNextClick,
    checkIsArrowHidden
  };
};

export { useCarousel };
export type { CarouselProps };
